module.exports = __webpack_public_path__ + "static/media/19_l_stena_0_0.763dc19e.png";